module.exports = __webpack_public_path__ + "static/img/nlp.17ff20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/nlp.png
// module id = U2xY
// module chunks = 0